import { ChangeDetectionStrategy, Component, Inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';

export interface BankAccountAssignDialogData {
	organization: { name: string; id: number };
}

@Component({
	imports: [MatDialogModule, MatButtonModule],
	template: `<h2 mat-dialog-title>Przypisanie organizacji</h2>

		<mat-dialog-content>
			Konto istnieje w bazie ale nie ma przypisanej organizacji. <br />Czy chcesz przypisać organizację
			<strong>{{ data.organization.name }} (ID: {{ data.organization.id }})</strong>?
		</mat-dialog-content>

		<mat-dialog-actions align="end">
			<button mat-raised-button color="warn" (click)="onCancel()">Nie</button>
			<button mat-raised-button color="primary" (click)="onConfirm()">Tak</button>
		</mat-dialog-actions>`,
	standalone: true,
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class OrganizationBankAccountAssignDialogComponent {
	constructor(
		public dialogRef: MatDialogRef<OrganizationBankAccountAssignDialogComponent>,
		@Inject(MAT_DIALOG_DATA) public data: BankAccountAssignDialogData,
	) {}

	onConfirm(): void {
		this.dialogRef.close(true);
	}

	onCancel(): void {
		this.dialogRef.close(false);
	}
}
